<template>
  <v-dialog v-model="dialog" width="800">
    <template v-slot:activator="{ on, attrs }">
      <v-card class="perso_card" v-bind="attrs" v-on="on" height="100%">
        <v-container class="py-0">
          <p
            class="my-0 pa-1 text-caption"
            style="
              position: absolute;
              text-align: right;
              padding: 8px;
              right: 4px;
              top: 2px;
            "
          >
            {{ dateStr(newsItem.date) }}
          </p>
          <v-row class="mb-0 mt-4 pt-2 mx-2">
            <v-col class="px-0">
              <h3 class="text-h5">
                {{ newsItem.title }}
              </h3>
            </v-col>
          </v-row>
          <v-row class="my-2 mx-2">
            <div class="mt-0 mb-4 py-0 text-left text-body-1">
              {{ newsItem.content.substring(0, nbCarac) }} ...
            </div>
          </v-row>
        </v-container>
      </v-card>
    </template>
    <!-- pop up -->
    <v-card>
      <v-card-title class="white--text text-h5 primary">
        {{ newsItem.title }}
      </v-card-title>

      <v-card-text class="my-4 text-body-1">
        {{ newsItem.content }}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">
          {{ $t("generic.Close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.perso_card {
  border: 1px solid rgba(0, 0, 0, 0.2);
  /* border: 1px solid rgba(202, 5, 56, 0.4); */
}
</style>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
  props: {
    newsItem: Object,
  },
  computed: {
    nbCarac() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 100;
        case "sm":
          return 150;
        case "md":
          return 150;
        case "lg":
          return 150;
        case "xl":
          return 200;
        default:
          return 200;
      }
    },
  },
  methods: {
    dateStr(date) {
      if (date) {
        const newdate = new Date(date);
        return newdate.toLocaleDateString("fr-FR");
      } else {
        return "";
      }
    },
  },
};
</script>